import React, { useEffect, useState } from 'react';
import { Button, Modal, message, Grid, Table } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { listService } from "../../services/ListService";
import { useParams } from "react-router";
import Menu from '../../components/Menu/Menu';
import MobileBottomMenu from '../../components/MobileBottomMenu/MobileBottomMenu';
import MobileMenu from "../../components/Menu/MobileMenu";
import { Link } from 'react-router-dom';
import Header from '../../components/Header/Header';
import { toast } from 'react-toastify';
import StatusTag from '../../components/StatusTag/StatusTag';

const SublistView = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const { listId, productId } = useParams();
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;

    useEffect(() => {
        setLoading(true);
        listService.getSublistDetails(Number(listId), Number(productId))
            .then((response) => {
                const raw = response.data; // ✅ use .data
                const items = raw.items || [];

                const transformed = items.map((item) => ({
                    id: item.id,
                    name: item.necessity_list_item?.product?.name || '—',
                    quantity: item.necessity_list_item?.quantity ?? '—',
                    indications: item.necessity_list_item?.supplementary_info || '—',
                    status: item.status,
                }));

                console.log('Transformed data:', transformed);
                setData(transformed);
            })
            .catch((error) => {
                console.error('Error fetching sublist details:', error);
                message.error('Failed to load sublist details');
            })
            .finally(() => {
                setLoading(false);
            });
    }, [listId, productId]);
    const handleEdit = (record) => {
        console.log('Edit clicked:', record);
    };
const handleDelete = (record) => {


  listService.deleteSublist(Number(listId), record.id, Number(productId))
    .then(() => {
      toast.success("Produsul a fost șters din sublistă.");
      setData(prev => prev.filter(item => item.id !== record.id));
    })
    .catch((err) => {
      console.error("Error deleting sublist item:", err);
      toast.error("Eroare la ștergerea produsului.");
    });
};
    const columns = [
        {
            title: 'Nume',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Cantitate',
            dataIndex: 'quantity',
            key: 'quantity',
        },
        {
            title: 'Indicatii',
            dataIndex: 'indications',
            key: 'indications',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => <StatusTag status={status} />,
        },
        {
            title: 'Editeaza',
            key: 'edit',
            render: (_, record) => (
                <Button
                    icon={<EditOutlined />}
                    onClick={() => handleEdit(record)}
                    type="link"
                />
            ),
        },
        {
            title: 'Sterge',
            key: 'delete',
            render: (_, record) => (
                <Button
                    icon={<DeleteOutlined />}
                    onClick={() => handleDelete(record)}
                    type="link"
                    danger
                />
            ),
        },
    ];


    const MobileList = () => {
        if (data.length === 0) {
            return (
                <div className="list__empty-state">
                    <p className="list__empty-state-text">Nu există produse în sublistă.</p>
                </div>
            );
        }

        return (
            <div className="list__mobile-table-wrapper">
                <div className="list__mobile-table-header">
                    <div className="list__mobile-table-header-cell list__mobile-table-header-name">Nume</div>
                    <div className="list__mobile-table-header-cell" style={{ width: '90px', flexShrink: 0 }}>Cant.</div>
                    <div className="list__mobile-table-header-cell" style={{ width: '120px', flexShrink: 0 }}>Status</div>
                    <div className="list__mobile-table-header-cell list__mobile-table-header-actions" style={{ width: '80px', flexShrink: 0 }}>Opt</div>
                </div>
                <div className="list__mobile-list">
                    {data.map((row) => (
                        <div key={row.id} className="list__mobile-card">
                            <div className="list__mobile-card-cell list__mobile-card-name" title={row.name}>
                                {row.name}
                            </div>
                            <div className="list__mobile-card-cell" style={{ width: '90px', flexShrink: 0 }}>
                                {row.quantity}
                            </div>
                            <div className="list__mobile-card-cell" style={{ width: '120px', flexShrink: 0 }}>
                                <StatusTag status={row.status} />
                            </div>
                            <div className="list__mobile-card-cell list__mobile-card-actions" style={{ width: '80px', flexShrink: 0 }}>
                                <Button icon={<EditOutlined />} onClick={() => handleEdit(row)} type="link" />
                                <Button icon={<DeleteOutlined />} onClick={() => handleDelete(row)} type="link" danger />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <div className='standard products list'>
            <Header />
            <div className='standard__mobile-header'>
                <img src='/images/logo.png' alt='logo' className='standard__only-mobile standard__mobile-logo' />
                <MobileMenu />
            </div>

            <div className='standard__container list'>
                <Menu />
                <div className='standard__wrapper'>
                    <div style={{ padding: 24, minHeight: 280 }}>
                        <h2 className='standard__page-title'>Listă produse</h2>
                        <h4 className='standard__page-info'>
                            În această pagină poți vizualiza și edita produsele magazinului. Momentan, în această etapă a proiectului, editările în listele de produse trebuie realizate exclusiv de către <b> higher management</b>.
                        </h4>
                        <Link to='/gata-de-trimis' className='standard__link'>
                            <div className='biding__back'>
                                <img src="/images/back.png" />
                                <h4>Înapoi</h4>
                            </div>
                        </Link>
                        <div style={{ height: '600px', overflowY: 'auto' }}>

                            {!isMobile ? (
                                <Table
                                    columns={columns}
                                    dataSource={data}
                                    rowKey="id"
                                    loading={loading}
                                    pagination={false}
                                    scroll={{ x: true }}
                                />
                            ) : (
                                <MobileList />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SublistView;